const ls = () => {
  const set = async (name, data, expMinutes) => {
    const now = new Date();
    const expiresAt = now.getTime() + expMinutes * 60 * 1000;

    const value = {
      data,
      expiresAt,
    };

    localStorage.setItem(name, JSON.stringify(value));
  };

  const get = (name) => {
    const itemStr = localStorage.getItem(name);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();

      if (!item.expiresAt || now > item.expiresAt) {
        localStorage.removeItem(name);
        return null;
      }

      return item.data;
    } catch (e) {
      localStorage.removeItem(name);
      return null;
    }
  };

  const del = async (name) => {
    localStorage.removeItem(name);
  };

  return { set, get, del };
};

export default ls;
